import { Link } from '@ngx-hal/models';

export class ItemProfileRead {
  static readonly type = '[ItemProfile] Read';

  constructor(readonly link: Link) {}
}
